export default "__VITE_ASSET__73ce7d15__"